// English translations
const en = {
  // Header translations
  transaction: 'Transaction',
  prop: 'Prop',
  explore: 'Explore',
  profit: 'Profit',
  assets: 'Assets',
  credit: 'Credit',
  balance: 'Balance',
  freeMargin: 'Free Margin',
  margin: 'Margin',
  marginLevel: 'Margin Level',
  openRealAccount: 'Open Real Account',
  
  // Market Watch
  marketWatch: 'Market Watch',
  favorites: 'Favorites',
  mostActive: 'Most Active',
  all: 'All',
  searchSymbols: 'Search symbols...',
  
  // Trading Actions
  buy: 'BUY',
  sell: 'SELL',
  close: 'Close',
  
  // Trading Modal
  market: 'Market',
  pending: 'Pending',
  currentPrice: 'Current Price',
  volume: 'Volume',
  lot: 'Lot',
  price: 'Price',
  stopLoss: 'Stop Loss',
  takeProfit: 'Take Profit',
  optional: 'Optional',
  marketOrder: 'Market Order',
  pendingOrder: 'Pending Order',
  executionPrice: 'Execution Price',
  cancel: 'Cancel',
  
  // Positions Panel
  openPositions: 'Open Positions',
  pendingOrders: 'Pending Orders',
  closedPositions: 'Closed Positions',
  finance: 'Finance',
  noOpenPositions: 'You have no open positions. Start trading to see your open positions here.',
  noPendingOrders: 'No pending orders found.',
  noClosedPositions: 'No closed positions found.',
  noFinancialHistory: 'No financial history found.',
  
  // Common terms
  symbol: 'Symbol',
  type: 'Type',
  pnl: 'P/L',
  swap: 'Swap',
  commission: 'Commission',
  spread: 'Spread',
  time: 'Time',
  
  // Account info
  equity: 'Equity',
  usedMargin: 'Used Margin',
  accountBalance: 'Account Balance',
  
  // Connection status
  connected: 'Connected',
  connecting: 'Connecting...',
  disconnected: 'Disconnected',
  
  // Mobile-specific translations
  accountSummary: 'Account Summary',
  selectField: 'Select Field',
  
  // Modal-specific translations
  buyOrder: 'Buy Order',
  sellOrder: 'Sell Order',
  
  // Navigation translations
  symbols: 'Symbols',
  chart: 'Chart',
  positions: 'Positions',
  
  // Account management
  account: 'Account',
  notifications: 'Notifications',
  markAllRead: 'Mark All Read',
  noNotifications: 'No notifications',
  
  // Market Watch Settings Modal
  marketWatchSettings: 'Market Watch Settings',
  general: 'General',
  display: 'Display',
  generalSettings: 'General Settings',
  displaySettings: 'Display Settings',
  autoRefresh: 'Auto Refresh',
  autoRefreshDesc: 'Automatically refresh prices',
  soundAlerts: 'Sound Alerts',
  soundAlertsDesc: 'Sound alerts for price changes',
  updateInterval: 'Update Interval',
  second: 'second',
  seconds: 'seconds',
  showSpread: 'Show Spread',
  showSpreadDesc: 'Show bid-ask spread',
  showVolume: 'Show Volume',
  showVolumeDesc: 'Show trading volume',
  decimalPlaces: 'Decimal Places',
  colorTheme: 'Color Theme',
  default: 'Default',
  greenRed: 'Green-Red',
  blueOrange: 'Blue-Orange',
  save: 'Save',

  // Technical Indicators
  indicators: 'Indicators',
  technicalIndicators: 'Technical Indicators',
  sma20: 'SMA 20',
  sma50: 'SMA 50',
  ema12: 'EMA 12',
  ema26: 'EMA 26',
  rsi14: 'RSI 14',
  bollingerBands: 'Bollinger Bands',
  movingAverage: 'Moving Average',
  exponentialMovingAverage: 'Exponential Moving Average',
  relativeStrengthIndex: 'Relative Strength Index',
  macd: 'MACD',
  stochastic: 'Stochastic',
  atr: 'ATR',
  
  // Chart loading states
  loadingChart: 'Loading Chart...',
  initializing: 'Initializing',
  chartReady: 'Chart Ready',

  // Positions table specific translations
  id: 'ID',
  amount: 'Amount',
  openTime: 'Açılış Zamanı',
  openPrice: 'Açılış Fiyatı',
  closePrice: 'Kapanış Fiyatı',
  actions: 'Actions',
  edit: 'Edit',
  searchSymbol: 'Symbol search...',
  loadingPositions: 'Pozisyonlar yükleniyor...',
  trading: 'İşlem',
  orders: 'Emirler',
  history: 'Geçmiş',
  openPositionsAndPending: 'Open Positions',
  previous: 'Önceki',
  next: 'Next',
  page: 'Previus',
  of: '/',
  noData: 'No data',
  itemsPerPage: 'Sayfa başına öğe',
};

export default en;